import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useTheme } from '../hooks/useTheme.js';
import { Box } from '../Box/index.js';
import { Text } from '../Text/Text.js';
import { Stack } from '../Stack/Stack.js';

var DialogBody = forwardRef(function DialogBody(_a, ref) {
    var sx = _a.sx, _b = _a.tone, tone = _b === void 0 ? "white" : _b, _c = _a.themeKey, themeKey = _c === void 0 ? "dialogBody" : _c, children = _a.children, textProps = _a.textProps, props = __rest(_a, ["sx", "tone", "themeKey", "children", "textProps"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps({ tone: tone, sx: sx }, {
        themeKey: themeKey,
        baseStyle: {
            gridArea: "body",
            overflow: "auto",
        },
    });
    return (jsx(Box, __assign({ ref: ref }, forwardProps, props, { children: jsx(Stack, __assign({ start: "20px", end: "20px" }, { children: jsx(Text, __assign({}, textProps, { children: children })) })) })));
});

export { DialogBody };
//# sourceMappingURL=DialogBody.js.map
